module.exports = __webpack_public_path__ + "img/rss-01.559c0207.svg";